// **  Initial State
const initialState = {

}

export const documentReducer = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state
	}
}
